module.exports = __webpack_public_path__ + "img/sec-circle4.97d6404.png";